export const UPDATE_END_DATE = "UPDATE_END_DATE";
export const UPDATE_START_DATE = "UPDATE_START_DATE";
export const UPDATE_DAYS_COUNT = "UPDATE_DAYS_COUNT";

//auth
export const AUTH_STARTED = "AUTH_STARTED";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_SUCCEEDED = "AUTH_SUCCEEDED";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const OPEN_SESSION_EXPIRATION_SNACKBAR = "OPEN_SESSION_EXPIRATION_SNACKBAR";

export const REQUEST_LOADER = "REQUEST_LOADER";
export const FETCH_CARS = "FETCH_CARS";
export const SET_RESERVATION = "SET_RESERVATION";
export const SET_RENT_DOC = "SET_RENT_DOC";
export const SET_RENT = "SET_RENT";
export const REMOVE_RENT = "REMOVE_RENT";
export const CLEAR_CARS = "CLEAR_CARS";
export const FETCH_CLIENTS = "FETCH_CLIENTS";
export const UPDATE_CLIENTS = "UPDATE_CLIENTS";
export const DELETE_CLIENT = "DELETE_CLIENT";

export const SET_CALENDAR_TYPE = "SET_CALENDAR_TYPE";
export const SET_POPOUT_DATA = "SET_POPOUT_DATA";

export const SET_PERIOD_DATA = "SET_PERIOD_DATA";
export const SET_WEEK_DATA = "SET_WEEK_DATA";
export const SET_MONTH_DATA = "SET_MONTH_DATA";
export const SET_QUARTER_DATA = "SET_QUARTER_DATA";

export const OPEN_SNACKBAR = "OPEN_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";

export const GET_CAR_RENTAL_LIST = "GET_CAR_RENTAL_LIST";
export const CLEAR_CAR_RENTAL_LIST = "CLEAR_CAR_RENTAL_LIST";

//user
export const SET_USER_DIALOG = "SET_USER_DIALOG";
export const SET_OPERATOR_NAME = "SET_OPERATOR_NAME";

//request
export const SET_COOKIES_ACCEPTED = "SET_COOKIES_ACCEPTED";